import { requestApplyPostSubmitUserAction } from 'api/operations/enrollmentService';
import { action, computed, makeObservable } from 'mobx';
import { createContext, useContext } from 'react';
import UploadDocumentsPageStore, {
  StepInteractor,
  UploadDocumentsDomainData,
} from 'store/modules/upload-documents/uploadDocumentsPageStore';
import { UploadStep } from 'types/documentsService';
import { ChecklistCard, ChecklistCompletionStatus, USER_ACTIONS } from 'types/enrollmentService';
import { UploadDocumentsModule } from 'store/modules/upload-documents/uploadDocumentsModule';

export default class PostSubmitDocumentsPageStore extends UploadDocumentsPageStore implements StepInteractor {
  public get thisStepHasBeenCompleted(): boolean {
    if (!this._enrollmentPeriodModule.postSubmitChecklist) {
      return true;
    }
    return (
      this._enrollmentPeriodModule.getStepCompletionStatus('POST_SUBMIT', ChecklistCard.POST_SUBMIT_DOCUMENTS) ===
      ChecklistCompletionStatus.COMPLETED
    );
  }

  public async completeStep(): Promise<void> {
    this._setIsLoading(true);
    await this._uploadDocumentsModule.submitDocuments();
    await requestApplyPostSubmitUserAction(this._domainData.entityId, USER_ACTIONS.COMPLETE_POST_SUBMIT_DOCUMENTS);
  }

  public async uncompleteStep(): Promise<void> {
    this._setIsLoading(true);
    await requestApplyPostSubmitUserAction(this._domainData.entityId, USER_ACTIONS.UNCOMPLETE_POST_SUBMIT_DOCUMENTS);
    await this.loadInitialData();
    this._setIsLoading(false);
  }

  constructor(domainData: UploadDocumentsDomainData) {
    super(domainData, UploadStep.POST_SUBMIT);

    this._uploadDocumentsModule = new UploadDocumentsModule({
      entityId: this._domainData.entityId,
      uploadStep: UploadStep.POST_SUBMIT,
    });

    makeObservable<PostSubmitDocumentsPageStore>(this, {
      thisStepHasBeenCompleted: computed,
      completeStep: action.bound,
      uncompleteStep: action.bound,
    });
  }
}

const PostSubmitDocumentsPageStoreContext = createContext(
  new PostSubmitDocumentsPageStore({ entityId: 'stub-entity' }),
);

export const usePostSubmitDocumentsPageStore = (): PostSubmitDocumentsPageStore => {
  return useContext(PostSubmitDocumentsPageStoreContext);
};

export { PostSubmitDocumentsPageStoreContext };
